export default {
    setEstimatedMortgage(state, payload) {
        state.estimatedMortgage = payload;
    }
};
